export default function downloadCsv(csv, filename) {
    var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    var link = document.createElement("a");
    var url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", filename);
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
export var dataToCsv = function (data) {
    var keys = [];
    // Get keys across ALL the objects in the collection passed
    data.map(function (row) {
        Object.keys(row).map(function (header) {
            if (!keys.includes(header)) {
                keys.push(header);
            }
        });
    });
    // Create csv lines from headers. Filling with "" if object doesn't have a property
    var csvRows = data.map(function (object) { return keys.map(function (key) { return object[key] || ""; }).join(","); });
    var csvHeaders = keys.join(",");
    var csvBody = csvRows.join("\n");
    // Start csv with \ufeff as the csv may contain utf-8 characters
    return "\uFEFF" + csvHeaders + "\n" + csvBody;
};
